// extracted by mini-css-extract-plugin
export default {"toolbar":"MindMap_toolbar__UDDLV"};